module.exports = __webpack_public_path__ + "img/medecin-pro.5032510e.png";